(function ($) {
    "use strict";

    /* ── Scroll-animation with IntersectionObserver (replaces WOW.js scroll listener) ── */
    var _animObserver    = null;
    var _mutationObserver = null;

    function observeWowEl(el) {
        if (el.classList.contains('animated')) return;
        if (el.closest && el.closest('#rs-header')) return;
        el.style.visibility = 'hidden';
        _animObserver.observe(el);
    }

    function initScrollAnimations(isRouteChange) {
        var all = document.querySelectorAll('.wow');

        // On route change: un-animate page elements (header stays put)
        if (isRouteChange) {
            all.forEach(function (el) {
                if (!el.closest('#rs-header')) {
                    el.classList.remove('animated');
                    el.style.visibility = 'hidden';
                    el.style.animationName = 'none';
                }
            });
        }

        // Create one persistent IntersectionObserver
        if (!_animObserver) {
            _animObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    var el  = entry.target;
                    var del = el.getAttribute('data-wow-delay')    || '0s';
                    var dur = el.getAttribute('data-wow-duration') || '0.8s';
                    el.style.animationDelay    = del;
                    el.style.animationDuration = dur;
                    el.style.animationName     = '';
                    el.style.visibility        = 'visible';
                    el.classList.add('animated');
                    _animObserver.unobserve(el);
                });
            }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
        }

        // Observe elements already in DOM
        all.forEach(observeWowEl);

        // MutationObserver catches .wow elements added AFTER this call
        // (Angular *ngFor / *ngIf content that loads after the API response)
        if (!_mutationObserver) {
            _mutationObserver = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType !== 1) return;
                        // Node itself might be .wow
                        if (node.classList && node.classList.contains('wow')) {
                            observeWowEl(node);
                        }
                        // Any .wow descendants inside the added node
                        if (node.querySelectorAll) {
                            node.querySelectorAll('.wow').forEach(observeWowEl);
                        }
                    });
                });
            });
            _mutationObserver.observe(document.body, { childList: true, subtree: true });
        }
    }

    /* ── Main header / plugin init ─────────────────────────────────── */
    function rsInitHeader() {

        // Mobile sidebar toggle
        $(document).off('click.rsSidebar').on('click.rsSidebar', '.sidebar-toggle, .header-bar-icon', function (e) {
            e.preventDefault();
            $('.offcanvas-area').addClass('info-open');
            $('.offcanvas-overlay').addClass('overlay-open');
            $('body').addClass('nav-open');
        });
        $(document).off('click.rsSidebarClose').on('click.rsSidebarClose', '.offcanvas-close, .offcanvas-close-icon, .offcanvas-overlay, .body-overlay', function () {
            $('.offcanvas-area').removeClass('info-open');
            $('.offcanvas-overlay').removeClass('overlay-open');
            $('body').removeClass('nav-open');
        });

        // Desktop dropdown hover
        $(document).off('mouseenter.rsDrop').on('mouseenter.rsDrop',
            '.main-menu > ul > li.menu-item-has-children', function () {
                $(this).find('> ul.submenu').stop(true, true).css({ opacity:'1', visibility:'visible', transform:'scaleY(1)', pointerEvents:'all' });
            }
        ).off('mouseleave.rsDrop').on('mouseleave.rsDrop',
            '.main-menu > ul > li.menu-item-has-children', function () {
                $(this).find('> ul.submenu').stop(true, true).css({ opacity:'0', visibility:'hidden', transform:'scaleY(0)', pointerEvents:'none' });
            }
        );

        // Mobile mean menu
        if ($.fn.meanmenu) {
            $('#mobile-menu').meanmenu({ meanMenuContainer: '.rs-offcanvas-menu', meanScreenWidth: '1199' });
        }

        // Scroll-in animations via IntersectionObserver (not WOW.js)
        initScrollAnimations(false);

        // Search toggle
        $(document).off('click.rsSearch').on('click.rsSearch', '.rs-search-toggle', function () {
            var $wrap  = $(this).closest('.header-search-wrapper');
            var $inner = $wrap.find('.header-search-inner');
            if ($inner.is(':visible')) {
                $inner.slideUp(200);
                $(this).find('.has-close').hide();
                $(this).find('.has-search').show();
            } else {
                $inner.slideDown(200);
                $(this).find('.has-close').show();
                $(this).find('.has-search').hide();
            }
        });

        // Jarallax — only init if elements exist on this page
        if (typeof jarallax === 'function' && document.querySelectorAll('.jarallax').length) {
            jarallax(document.querySelectorAll('.jarallax'), { speed: 0.5 });
        }

        // MagnificPopup
        if ($.fn.magnificPopup) {
            $('.popup-image').magnificPopup({ type: 'image', gallery: { enabled: true } });
            $('.popup-video').magnificPopup({ type: 'iframe' });
        }

        // Nice Select
        if ($.fn.niceSelect) { $('select').niceSelect(); }

        // Data-background
        $('[data-background]').each(function () {
            $(this).css('background-image', 'url(' + $(this).attr('data-background') + ')');
        });

        // Back-to-top click
        $('#backtotop-wrap').off('click.backtotop').on('click.backtotop', function () {
            if (window._smoothScrollTo) { window._smoothScrollTo(0); }
            else { $('html, body').animate({ scrollTop: 0 }, 500); }
        });

        // Banner Swiper removed
    }

    // Initial load
    $(document).ready(function () { setTimeout(rsInitHeader, 400); });

    // Angular route change detection
    var _lastPath = location.pathname;
    setInterval(function () {
        if (location.pathname !== _lastPath) {
            _lastPath = location.pathname;
            setTimeout(function () {
                initScrollAnimations(true);
                rsInitHeader();
            }, 400);
        }
    }, 300);

    // ── Other plugins ──────────────────────────────────────────────────

    // Button hover ripple
    $('.default-btn')
        .on('mouseenter', function (e) { var o = $(this).offset(); $(this).find('span').css({ top: e.pageY - o.top, left: e.pageX - o.left }); })
        .on('mouseout',   function (e) { var o = $(this).offset(); $(this).find('span').css({ top: e.pageY - o.top, left: e.pageX - o.left }); });

    $(document)
        .on('mouseenter', '.rs-btn', function () { $(this).find('.rs-icon').css('animation', 'btnHoverEffect 0.5s'); })
        .on('mouseleave', '.rs-btn', function () { $(this).find('.rs-icon').css('animation', 'btnHoverEffectReverse 0.5s'); });

    // FAQ accordion
    $('.accordion').find('.accordion-title').on('click', function () {
        $(this).toggleClass('active');
        $(this).next().slideToggle('fast');
        $('.accordion-content').not($(this).next()).slideUp('fast');
        $('.accordion-title').not($(this)).removeClass('active');
    });

    // Owl carousels
    if ($.fn.owlCarousel) {
        $('.partner-slides').owlCarousel({ loop:true, nav:false, dots:false, autoplayHoverPause:true, autoplay:true, margin:30, responsive:{ 0:{items:2}, 576:{items:3}, 768:{items:4}, 1200:{items:5} } });
        $('.team-slider').owlCarousel({ loop:true, nav:true, dots:false, margin:30, autoplayHoverPause:true, autoplay:true, navText:["<i class='flaticon-left-chevron'></i>","<i class='flaticon-right-chevron'></i>"], responsive:{ 0:{items:1}, 576:{items:2}, 768:{items:3} } });
        $('.feedback-slides').owlCarousel({ loop:true, nav:false, dots:true, autoplayHoverPause:true, autoplay:true, responsive:{ 0:{items:1}, 768:{items:2}, 1200:{items:3}, 1550:{items:4} } });
    }

    // Popup
    if ($.fn.magnificPopup) {
        $('.popup-btn').magnificPopup({ type: 'image', gallery: { enabled: true } });
        $('.popup-youtube').magnificPopup({ disableOn: 320, type: 'iframe', mainClass: 'mfp-fade', removalDelay: 160, preloader: false, fixedContentPos: false });
    }

}(jQuery));


/* ── NORMAL BROWSER SCROLL ─────────────────────────────────────────────
   Removed Lenis to fix flashing and jerking. 
──────────────────────────────────────────────────────────────────────── */
(function () {
    'use strict';
    var _cache   = {};
    var _navbars = null;
    function g(k, sel) { return _cache[k] || (_cache[k] = sel ? document.querySelector(sel) : document.getElementById(k)); }

    function updateScrollUI(y) {
        var sticky = g('rs-sticky-header');
        var circle = g('circle', '.progress-circle');
        var btt    = g('backtotop-wrap');
        if (!_navbars) { _navbars = Array.from(document.querySelectorAll('.navbar-area')); }

        if (sticky) { sticky.classList[y > 200 ? 'add' : 'remove']('active'); }
        _navbars.forEach(function (el) { el.classList[y > 120 ? 'add' : 'remove']('is-sticky'); });

        var docH = document.documentElement.scrollHeight - window.innerHeight;
        var prog = docH > 0 ? y / docH : 0;
        if (circle) { circle.style.strokeDashoffset = String(113.1 - 113.1 * prog); }

        if (btt) { btt.classList[y > 150 ? 'add' : 'remove']('active-progress'); }
    }

    var _ticking = false;
    window.addEventListener('scroll', function() {
        if (!_ticking) {
            window.requestAnimationFrame(function() {
                updateScrollUI(window.scrollY);
                _ticking = false;
            });
            _ticking = true;
        }
    });

    // Run once on load
    document.addEventListener('DOMContentLoaded', function() {
        updateScrollUI(window.scrollY);
    });

    window._smoothScrollTo = function (y) {
        window.scrollTo({ top: y, behavior: 'smooth' });
    };

    var _lp = location.pathname;
    setInterval(function () {
        if (location.pathname !== _lp) {
            _lp = location.pathname;
            _cache = {};
            _navbars = null;
            window.scrollTo(0, 0);
        }
    }, 100);
}());

/* ══════════════════════════════════════════════════════════════
   EIKRA DESIGN SYSTEM — JavaScript helpers
   • Tab switching
   • Scroll reveal (IntersectionObserver)
   (The hero banner slider lives in the Swiper block above —
   rsInitBannerSwiper() — not here.)
══════════════════════════════════════════════════════════════ */
(function () {
    'use strict';

    /* ── Eikra Tab Switching ────────────────────────────────── */
    function initEikreTabs() {
        document.querySelectorAll('.eikra-tabs-nav').forEach(function (nav) {
            nav.querySelectorAll('li').forEach(function (li) {
                li.addEventListener('click', function () {
                    var tabId = li.getAttribute('data-tab');
                    var parent = li.closest('.eikra-about-content') || document;

                    /* Deactivate all nav items */
                    nav.querySelectorAll('li').forEach(function (el) { el.classList.remove('active'); });
                    li.classList.add('active');

                    /* Deactivate all panes */
                    parent.querySelectorAll('.eikra-tab-pane').forEach(function (p) { p.classList.remove('active'); });
                    var target = parent.querySelector('#' + tabId);
                    if (target) { target.classList.add('active'); }
                });
            });
        });
    }

    /* ── Scroll Reveal for .ekra-reveal elements ────────────── */
    var _ekraObserver = null;

    function initEikraReveal() {
        var els = document.querySelectorAll('.ekra-reveal');
        if (!els.length) return;

        if (!_ekraObserver) {
            _ekraObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                        _ekraObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
        }

        els.forEach(function (el) {
            if (!el.classList.contains('visible')) {
                _ekraObserver.observe(el);
            }
        });

        /* MutationObserver to catch dynamically added .ekra-reveal and counter elements */
        if (!window._ekraMutObs) {
            window._ekraMutObs = new MutationObserver(function (mutations) {
                var needCounterInit = false;
                mutations.forEach(function (m) {
                    m.addedNodes.forEach(function (node) {
                        if (node.nodeType !== 1) return;
                        if (node.classList && node.classList.contains('ekra-reveal')) { _ekraObserver.observe(node); }
                        if (node.querySelectorAll) {
                            node.querySelectorAll('.ekra-reveal').forEach(function (el) { _ekraObserver.observe(el); });
                            if (node.querySelectorAll('.rtin-counter-num').length) { needCounterInit = true; }
                        }
                        if (node.classList && node.classList.contains('rtin-counter-num')) { needCounterInit = true; }
                    });
                });
                if (needCounterInit) { setTimeout(initEikraCounters, 100); }
            });
            window._ekraMutObs.observe(document.body, { childList: true, subtree: true });
        }
    }

    /* ── Eikra Counter Animation ──────────────────────────── */
    var _counterObserver = null;

    function animateCounterNum(el) {
        var target = parseInt(el.getAttribute('data-num') || '0', 10);
        var span = el.querySelector('.counter');
        if (!span) return;
        if (target === 0) { span.textContent = '0'; return; }

        var duration = 2000;
        var startTime = null;

        function step(ts) {
            if (!startTime) startTime = ts;
            var progress = Math.min((ts - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            span.textContent = Math.floor(eased * target).toLocaleString();
            if (progress < 1) { requestAnimationFrame(step); }
            else { span.textContent = target.toLocaleString(); }
        }
        requestAnimationFrame(step);
    }

    function initEikraCounters() {
        var els = document.querySelectorAll('.rtin-counter-num');
        if (!els.length) return;

        if (!_counterObserver) {
            _counterObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        animateCounterNum(entry.target);
                        _counterObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.4 });
        }

        els.forEach(function (el) {
            if (!el.getAttribute('data-counted')) {
                el.setAttribute('data-counted', '');
                _counterObserver.observe(el);
            }
        });
    }

    /* ── Boot ── */
    function eikraInit() {
        initEikreTabs();
        initEikraReveal();
        initEikraCounters();
    }

    /* On DOM ready */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { setTimeout(eikraInit, 200); });
    } else {
        setTimeout(eikraInit, 200);
    }

    /* On Angular route changes (re-init tabs + reveal on new page) */
    var _ekraPath = location.pathname;
    setInterval(function () {
        if (location.pathname !== _ekraPath) {
            _ekraPath = location.pathname;
            _ekraObserver = null; /* reset so new elements are observed */
            _counterObserver = null;
            setTimeout(eikraInit, 400);
        }
    }, 200);

}());
